import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { MenuController, Platform } from '@ionic/angular';
import { SigninService } from '../services/signin.service';
import { Login } from '../authentication.model';
import { Storage } from '@ionic/storage';
import { AuthSessionService } from '@app/core/services/auth-session.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MessageConfig } from '@app/shared/constants/constant';
import { UtilService } from '@app/core/services/util.service';
import { SideMenuService } from '@app/right-menu/services/side-menu.service';
import { CommonService } from '@app/shared/services/common.service';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.page.html',
    styleUrls: ['./signin.page.scss'],
    standalone: false
})
export class SigninPage implements OnInit, AfterViewInit, OnDestroy {
  public logIn: Login = new Login();
  public passwordType = 'password';
  public signinForm: UntypedFormGroup;
  public messageDisplay = MessageConfig;
  constructor(
    private menuCtrl: MenuController,
    private router: Router,
    private signInService: SigninService,
    private authSessionService: AuthSessionService,
    private formBuilder: UntypedFormBuilder,
    private utilService: UtilService,
    private storage: Storage,
    private platform: Platform,
    private sideMenu: SideMenuService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private elRef: ElementRef
  ) {
  }
  private _ariaObserver: MutationObserver | undefined;

  public ngOnInit() {
    this.validForm();

  }
  public ionViewWillEnter() {
    this.willenterLogout();
    this.menuCtrl.enable(false);
    this.sideMenu.closedChat.next(false);
    this.menuCtrl.enable(false, 'end');
  }

  private blurActiveElement(): void {
    const active = document.activeElement as HTMLElement | null;
    if (active?.blur) {
      active.blur();
    }
  }

  public willenterLogout() {
    this.storage.get('userdetails').then((val) => {
      if (val) {
        this.authSessionService.logOut();
      }
    });
  }

  public ionViewWillLeave() {
    this.blurActiveElement();
  }

  public ngAfterViewInit(): void {
    try {
      const target = this.elRef.nativeElement ?? document.querySelector('app-signin');
      if (target) {
        this._ariaObserver = new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.type === 'attributes' && (m as MutationRecord).attributeName === 'aria-hidden') {
              const val = (m.target as Element).getAttribute('aria-hidden');
              if (val === 'true') {
                this.blurActiveElement();
              }
            }
          }
        });
        this._ariaObserver.observe(target, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
    } catch (e) {
      // ignore
    }
  }

  public ionViewWillUnload() {
    this.menuCtrl.enable(true);
  }

  public ngOnDestroy(): void {
    if (this._ariaObserver) {
      this._ariaObserver.disconnect();
      this._ariaObserver = undefined;
    }
  }

  public goToDashboard() {
    this.menuCtrl.enable(true, 'left');
    this.menuCtrl.open('right');
    this.router.navigateByUrl('invoices');
  }
  public signup() {
    this.router.navigateByUrl('register');
  }
  public forgotPassword() {
    this.router.navigateByUrl('forgot');
  }
  public login(form) {
    this.signInService.authetication(form.value);
  }

 public keyDownFunction(event,signinForm) {
  if(signinForm.valid)
  {
    if (event.keyCode === 13) {
      this.login(signinForm)
    }
  }
  else{
    this.commonService.dismissLoader();
  }
}
  public showPassword() {
    if (this.passwordType == 'password') {
      this.passwordType = 'text';
    } else {
      this.passwordType = 'password';
    }
  }
  public validForm() {
    this.signinForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      password: [
        this.logIn.password,
        Validators.compose([Validators.required]),
      ],
    });
  }
}
